import { Route, Routes, Navigate } from 'react-router-dom';

import { ForgotPassword } from 'src/features/auth/routes/ForgotPassword';
import { Login } from 'src/features/auth/routes/Login';
import { Register } from 'src/features/auth/routes/Register';
import { ResetPassword } from 'src/features/auth/routes/ResetPassword';

const AuthRoutes = () => {
    return (
        <Routes>
            <Route path="join/:invitationParkingId/:invitationId" element={<Register />} />
            <Route path="login" element={<Login />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    );
};

export { AuthRoutes };
